"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerManager = void 0;
var cacheManager_1 = require("./cache/cacheManager");
var videoPlayer_1 = require("./videoPlayer");
var shaka_player_1 = require("shaka-player");
var debug_1 = __importDefault(require("debug"));
var log = debug_1.default('persie:pm');
var defaultConf = {
    cacheOpts: {},
    installPolyfill: false,
};
var PlayerManager = /** @class */ (function () {
    function PlayerManager(_opts) {
        if (_opts === void 0) { _opts = {}; }
        this.players = new Map();
        this.opts = Object.assign({}, defaultConf, _opts);
        this.handlePlayerDestroyed = this.handlePlayerDestroyed.bind(this);
        this.cacheManager = new cacheManager_1.CacheManager(this.opts.cacheOpts);
    }
    PlayerManager.prototype._init = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        log('init', this.opts);
                        // Install built-in polyfills to patch browser incompatibilities.
                        if (this.opts.installPolyfill) {
                            shaka_player_1.polyfill.installAll();
                        }
                        // Check to see if the browser supports the basic APIs Shaka needs.
                        if (!shaka_player_1.Player.isBrowserSupported()) {
                            throw new Error('Browser not supported!');
                        }
                        return [4 /*yield*/, this.cacheManager.init()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PlayerManager.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.initializing) {
                    this.initializing = this._init();
                }
                return [2 /*return*/, this.initializing];
            });
        });
    };
    PlayerManager.prototype.getAllPlayers = function () {
        return Array.from(this.players.values());
    };
    PlayerManager.prototype.getPlayer = function (videoContainer) {
        return this.players.get(videoContainer);
    };
    PlayerManager.prototype.addPlayer = function (videoContainer, configuration) {
        if (configuration === void 0) { configuration = {}; }
        if (this.players.has(videoContainer)) {
            throw new Error('Video container is already in use!');
        }
        var player = new videoPlayer_1.VideoPlayer(videoContainer, configuration, this.handlePlayerDestroyed);
        this.players.set(videoContainer, player);
        return player;
    };
    // This is a utility function that detects if there was an existing player on the same video element
    // that is in the process of getting destroyed and adds the new player afterwards
    PlayerManager.prototype.addPlayerSafeAsync = function (videoContainer, configuration) {
        if (configuration === void 0) { configuration = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var existingPlayer;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        existingPlayer = this.players.get(videoContainer);
                        if (!(existingPlayer === null || existingPlayer === void 0 ? void 0 : existingPlayer.isDestroying())) return [3 /*break*/, 2];
                        return [4 /*yield*/, existingPlayer.waitUntilDestroyed()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.addPlayer(videoContainer, configuration)];
                }
            });
        });
    };
    PlayerManager.prototype.removePlayer = function (videoContainer, removeCache) {
        if (removeCache === void 0) { removeCache = false; }
        return __awaiter(this, void 0, void 0, function () {
            var player, src;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        player = this.getPlayer(videoContainer);
                        if (!player) return [3 /*break*/, 3];
                        src = player.getConfiguration().src;
                        return [4 /*yield*/, player.destroy()];
                    case 1:
                        _a.sent();
                        this.players.delete(videoContainer);
                        if (!removeCache) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.cacheManager.removeCachedVideoData(src)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    PlayerManager.prototype.handlePlayerDestroyed = function (videoPlayer) {
        if (videoPlayer === this.players.get(videoPlayer.videoContainer)) {
            // remove iff another video player has not been created using the same video container
            this.players.delete(videoPlayer.videoContainer);
        }
    };
    PlayerManager.prototype.removeAllPlayers = function (removeCache) {
        if (removeCache === void 0) { removeCache = false; }
        return __awaiter(this, void 0, void 0, function () {
            var allContainers;
            var _this = this;
            return __generator(this, function (_a) {
                allContainers = Array.from(this.players.keys());
                return [2 /*return*/, Promise.all(allContainers.map(function (c) { return _this.removePlayer(c, removeCache); }))];
            });
        });
    };
    PlayerManager.prototype.removeCachedVideoData = function (manifestUri) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // video shall not be active when this is called
                return [2 /*return*/, this.cacheManager.removeCachedVideoData(manifestUri)];
            });
        });
    };
    PlayerManager.prototype.getPlayersCachedSegmentsSize = function (player) {
        return __awaiter(this, void 0, void 0, function () {
            var segmentUris;
            return __generator(this, function (_a) {
                segmentUris = player.getActiveSegmentUris();
                return [2 /*return*/, this.cacheManager.getCachedSegmentsSize(segmentUris)];
            });
        });
    };
    PlayerManager.prototype.clearDB = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cacheManager.clearDB().catch(function (err) { return log(err); })];
            });
        });
    };
    PlayerManager.prototype.deleteDB = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.cacheManager.deleteDB().catch(function (err) { return log(err); })];
            });
        });
    };
    PlayerManager.prototype.stop = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        log('stop');
                        return [4 /*yield*/, this.removeAllPlayers()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.cacheManager.stop()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // This is mostly for demo purposes!
    PlayerManager.prototype.addPlayersByClassName = function (className) {
        var e_1, _a;
        var videoContainers = document.getElementsByClassName(className);
        try {
            for (var videoContainers_1 = __values(videoContainers), videoContainers_1_1 = videoContainers_1.next(); !videoContainers_1_1.done; videoContainers_1_1 = videoContainers_1.next()) {
                var videoContainer = videoContainers_1_1.value;
                this.addPlayer(videoContainer);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (videoContainers_1_1 && !videoContainers_1_1.done && (_a = videoContainers_1.return)) _a.call(videoContainers_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    // This is mostly for demo purposes!
    PlayerManager.prototype.playAll = function () {
        return Promise.all(Array.from(this.players.values()).map(function (p) { return p.load().then(function () { return p.play(); }).catch(function (err) { return log(err); }); }));
    };
    return PlayerManager;
}());
exports.PlayerManager = PlayerManager;
